import { generateCSSSelector } from 'fela-utils';

export default function generateCacheEntry(type, className, property, value) {
  var pseudo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var media = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var support = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';

  return {
    type: type,
    className: className,
    selector: generateCSSSelector(className, pseudo),
    declaration: property + ':' + value,
    pseudo: pseudo,
    media: media,
    support: support
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/rehydration/generateCacheEntry.js
// module id = 1182
// module chunks = 0